import React from 'react';
import { Instagram, Facebook, Mail, Phone, MapPin, Heart } from 'lucide-react';
import { brandInfo, contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { href: '#inicio', label: 'Início' },
    { href: '#servicos', label: 'Serviços' },
    { href: '#produtos', label: 'Mary Kay' },
    { href: '#sobre', label: 'Sobre Nós' },
    { href: '#marcacoes', label: 'Marcações' },
    { href: '#contactos', label: 'Contactos' },
  ];

  const servicesLinks = [
    'Depilação a Laser',
    'Lipozero',
    'Pressoterapia',
    'Sessões de Beleza',
    'Produtos Mary Kay',
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0a0a0a] border-t border-[#C1A54F]/10">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src={brandInfo.logo}
              alt={brandInfo.name}
              className="h-16 w-auto mb-6"
            />
            <p className="text-[#bbb5ae] text-sm leading-relaxed mb-6">
              Beleza e tratamento corporal de excelência em Oliveirinha. 
              A sua melhor versão começa aqui.
            </p>
            {/* Social Links */}
            <div className="flex space-x-3">
              <a
                href={contactInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-[#C1A54F]/30 flex items-center justify-center
                         hover:border-[#C1A54F] hover:bg-[#C1A54F]/10 transition-all"
                aria-label="Instagram"
              >
                <Instagram className="text-[#E1C57C]" size={18} />
              </a>
              <a
                href={contactInfo.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-[#C1A54F]/30 flex items-center justify-center
                         hover:border-[#C1A54F] hover:bg-[#C1A54F]/10 transition-all"
                aria-label="Facebook"
              >
                <Facebook className="text-[#E1C57C]" size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg text-[#E1C57C] mb-6">Navegação</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-[#bbb5ae] hover:text-[#E1C57C] text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display text-lg text-[#E1C57C] mb-6">Serviços</h4>
            <ul className="space-y-3">
              {servicesLinks.map((service, index) => (
                <li key={index}>
                  <a
                    href="#servicos"
                    onClick={(e) => scrollToSection(e, '#servicos')}
                    className="text-[#bbb5ae] hover:text-[#E1C57C] text-sm transition-colors"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-display text-lg text-[#E1C57C] mb-6">Contactos</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <MapPin className="text-[#E5B1C4] mr-3 flex-shrink-0 mt-1" size={16} />
                <span className="text-[#bbb5ae] text-sm">
                  {contactInfo.address}<br />
                  {contactInfo.postalCode}
                </span>
              </li>
              <li className="flex items-center">
                <Phone className="text-[#E5B1C4] mr-3 flex-shrink-0" size={16} />
                <a
                  href={`tel:${contactInfo.phone}`}
                  className="text-[#bbb5ae] hover:text-[#E5B1C4] text-sm transition-colors"
                >
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="text-[#E5B1C4] mr-3 flex-shrink-0" size={16} />
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-[#bbb5ae] hover:text-[#E5B1C4] text-sm transition-colors"
                >
                  {contactInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#C1A54F]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-[#736c64] text-sm">
              © {currentYear} Shape & Shine by Sandra Silva. Todos os direitos reservados.
            </p>
            <p className="text-[#736c64] text-xs mt-2 md:mt-0 flex items-center">
              Feito com <Heart size={12} className="text-[#E5B1C4] mx-1" /> em Oliveirinha
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
